'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';

let signalstopic = 'goldensparrowcapital-signals';

const PreWatchersComponent = props => {
  const {
    user
  } = useUserContext();
  const [preWatchers, setPreWatchers] = useState([])
  // Store current prices by symbol for efficient updates
  const [currentPrices, setCurrentPrices] = useState({});
  const [section, setSection] = useState('Active');
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
    const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
    const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [popupPreWatcher, setPopupPreWatcher] = useState(null);
  const [fvgLow, setFvgLow] = useState({}); // { [uuid]: value }
  const [fvgHigh, setFvgHigh] = useState({}); // { [uuid]: value }
  const [isProcessing, setIsProcessing] = useState(false)
  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
      if (mqttClientRef.current) return; // already connected
         let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
         const gsccookie = Cookies.get('gsccookie') || null;
         const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
           clientId: clientID,
           username: 'user-jwt',
           password: gsccookie,
           clean: true,
           rejectUnauthorized: true,
           reconnectPeriod: 60000,
         });
         mqttClientRef.current = newClient;
         setClient(newClient);
      newClient.on('connect', async () => {
        console.log('Connected to MQTT:', new Date().toLocaleTimeString());

        newClient.publish('GET_PREWATCHERS', JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
            // console.log('GET_PREWATCHERS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });

        newClient.unsubscribe('RECEIVE_PREWATCHERS_WEB');

        newClient.subscribe('RECEIVE_PREWATCHERS_WEB', err => {
          if (!err) {
            // console.log('Topic subscribed:RECEIVE_PREWATCHERS');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });
        
        newClient.on('message', (topic, message) => {
          console.log('Received topic:', topic, new Date().toLocaleTimeString());
          if (topic == 'RECEIVE_PREWATCHERS_WEB') {
            let raw = JSON.parse(message);
            setPreWatchers(raw.preWatchers);
            setLastUpdated(new Date().valueOf());
            setCurrentPrices({});
          }
          if (topic === 'UPDATE_PREWATCHER') {
            let obj = JSON.parse(message);
            let newPreWatcher = obj.preWatcher;
            setCurrentPrices(prev => {
              if (!newPreWatcher.symbol || newPreWatcher.currentPrice === undefined) return prev;
              const newPrice = Number(newPreWatcher.currentPrice).toFixed(newPreWatcher.numberOfDecimalValues);
              if (prev[newPreWatcher.symbol] === newPrice) return prev;
              return { ...prev, [newPreWatcher.symbol]: newPrice };
            });
            setPreWatchers(prev => {
              const index = prev.findIndex(item => item.symbol === newPreWatcher.symbol && item.uuid === newPreWatcher.uuid);
              if (index !== -1) {
                const updatedItem = {
                  ...prev[index],
                  ...newPreWatcher,
                };
                return [
                  ...prev.slice(0, index),
                  updatedItem,
                  ...prev.slice(index + 1),
                ];
              }
              return prev;
            });
            setLastUpdated(new Date().valueOf());
          }
        });
      });

  }, [setClient, setIsProcessing]);
 

  useEffect(() => {
    async function fetchData() {
      if (user.userType == "ADMIN") {
        await _connectMQTT(props);
      }
    }
    fetchData();
  }, []);

  async function handleDelete(uuid) {
    // console.log("Deleting PreWatcher:", uuid)
    //remove preWatcher from preWatchers state
    setPreWatchers(prevPreWatchers => prevPreWatchers.filter(preWatcher => preWatcher.uuid !== uuid));

    const gsccookie = Cookies.get('gsccookie') || null;
    console.log("Deleting PreWatcher:", uuid, gsccookie)

    client.publish("DELETE_PREWATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {
     
    });
  }



  // Memoize preWatchers with current prices for rendering
  const preWatchersWithPrices = React.useMemo(() => {
    return preWatchers.map(preWatcher => {
      const price = currentPrices[preWatcher.symbol] || preWatcher.currentPrice;
      return { ...preWatcher, currentPrice: price };
    });
  }, [preWatchers, currentPrices]);

  return preWatchers ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      <PreWatcherPopup
        preWatcher={popupPreWatcher}
        onClose={() => {
          setPopupPreWatcher(null);
        }}
        // onUpdatePreWatcher={updatedPreWatcher => {
        //   setPopupPreWatcher(updatedPreWatcher);
        //   setPreWatchers(arr => arr.map(obj => (obj.uuid === updatedPreWatcher.uuid ? updatedPreWatcher : obj)));
        // }}
        transitionPreWatcherToWatcher={object => {

          const gsccookie = Cookies.get('gsccookie') || null;
          client.publish('TRANSITION_PREWATCHER_TO_WATCHER', JSON.stringify({ token: gsccookie, preWatcher: object.preWatcher, limitPrice: object.limitPrice, stopLossPrice: object.stopLossPrice, currentPrice: object.symbolCurrentPrice }), err => {
            if (!err) {
              setPopupPreWatcher(null);
            } else {
              console.error('TRANSITION_PREWATCHER_TO_WATCHER Error:', err);
              alert("Error: Transitioning to Watcher")
            }
          });
        }}
      />
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>

      {/* StrategyB */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{ marginBottom: 10 }}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          StrategyB ({preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB").length})
        </h1>


        {/* Other stages */}
        <div style={{ padding: 5, margin: 5, flexDirection: "row", display: "flex", columnGap: 10 }}>
         
          <div className="py-2 px-4 text-center bg-white dark:bg-gray-600" style={{ padding: 5, margin: 5, borderRadius : 10 }}>
            <h4 className="text-sm">STAGE2</h4>
            <h2 className="text-md">{preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE2").length}</h2>
          </div>
           <div className="py-2 px-4 text-center bg-white dark:bg-gray-600" style={{ padding: 5, margin: 5,borderRadius : 10 }}>
            <h4 className="text-sm">STAGE1</h4>
            <h2 className="text-md">{preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE1").length}</h2>
          </div>

        </div>

         {/* STAGE1 */}
         {preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE1")?.length > 0 ?
<>
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          STAGE1
        </h3>
        <div className="py-2 px-4 text-center bg-white dark:bg-gray-600 rounded-lg"
         style={{ padding: 5, margin: 5, borderRadius : 10 }} >
           {preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE1").sort((a, b) => new Date(b.lastChangedDate) - new Date(a.lastChangedDate)).map((preWatcher, index) => {
                return (
                //all the following should appear in straight line, seperated by comma
                <span key={preWatcher.uuid} className="text-xs">{preWatcher.symbol}{index < preWatchersWithPrices.length - 1 ? ', ' : ''}</span>
                );
              })}
          </div>  </>: null }

        {/* STAGE2 */}
        {preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE2")?.length > 0 ?
<>
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          STAGE2
        </h3>
        <div style={{ padding: 5 }}>
          <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="text-sm py-2 px-4 border-b">S.No.</th>
  <th className="text-sm py-2 px-4 border-b">Last Updated Date & Time</th>
                <th className="text-sm py-2 px-4 border-b">Creation Date & Time</th>
              
                <th className="text-sm py-2 px-4 border-b">Symbol & Current Price</th>

                {props.user.userType == 'ADMIN' ? (
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                ) : null}

                {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
              </tr>
            </thead>

            <tbody>
              {/* sort by desc order */}
              {preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "StrategyB" && preWatcher?.currentStage == "STAGE2").sort((a, b) => new Date(b.lastChangedDate) - new Date(a.lastChangedDate)).map((preWatcher, index) => {

                return (
                  <tr key={preWatcher.uuid}>
                    {/* S.No */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                    </td>

                      {/* Updated Date & Time */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      {new Date(preWatcher.lastChangedDate).toLocaleDateString() +
                        ', ' +
                        new Date(preWatcher.lastChangedDate).toLocaleTimeString(undefined, {
                          hour12: true,
                        })}
                    </td>

                    {/* Creation Date & Time */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      {new Date(preWatcher.creationDate).toLocaleDateString() +
                        ', ' +
                        new Date(preWatcher.creationDate).toLocaleTimeString(undefined, {
                          hour12: true,
                        })}
                    </td>
                   

                    {/* Symbol */}
                    <td className="py-2 px-4 border-b">
                           <div style={{ alignItems: 'center', display: 'flex' }}>
                         
                          <button
                            style={{
                              backgroundColor: '#0474c9',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() => {
                              // if (props.user?.userType == 'ADMIN') {

                              //   window.open(
                              //     'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // } else {
                              //   window.open(
                              //     'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // }
                            }
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol}</h4>

                           
                             
                            </div>
                          </button>
                           {props.user?.userType == 'ADMIN' ?

                              <a
                                href={`https://www.coinglass.com/tv/Binance_${preWatcher.symbol}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                                title="CoinGlass"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ display: 'inline', verticalAlign: 'middle' }}
                                >
                                  {/* Dark background circle matching trading terminal themes */}
                                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                                  <path
                                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  {/* Subtle outer border for depth */}
                                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                                </svg>
                              </a>
                              : null}
                            <a
                              href={`https://www.tradingview.com/chart/?symbol=BINANCE%3A${preWatcher.symbol}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                              title="TradingView"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'inline', verticalAlign: 'middle' }}
                              >
                                {/* Standard Terminal Background */}
                                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                                {/* Border for UI consistency */}
                                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                              </svg>
                            </a>
                            </div>
                        </td>

                    {/* Delete Button */}
                    <td className="py-2 px-4 border-b">
                      <div style={{ textAlign: 'center' }}>
                        <button
                          style={{
                            // backgroundColor: '#00ff00',

                            padding: 5,
                          }}
                          onClick={() => handleDelete(preWatcher.uuid)}
                        >
                          {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="size-4"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                );

              })}
            </tbody>
          </table>
          <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
            *Note: Signals will be removed automatically after 7 days.
          </h6>
        </div>
        </>: null }


      </div>

{/* RSI-Minus30-Plus70 */}

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{ marginBottom: 10 }}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          RSI-Minus30-Plus70 ({preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "RSI-Minus30-Plus70").length})
        </h1>


        {/* Other stages */}
        <div style={{ padding: 5, margin: 5, flexDirection: "row", display: "flex", columnGap: 10 }}>
         
          <div className="py-2 px-4 text-center bg-white dark:bg-gray-600 " style={{ padding: 5, margin: 5, borderRadius : 10 }}>
            <h4 className="text-sm">STAGE2</h4>
            <h2 className="text-md">{preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "RSI-Minus30-Plus70" && preWatcher?.currentStage == "STAGE2").length}</h2>
          </div>
           <div className="py-2 px-4 text-center bg-white dark:bg-gray-600" style={{ padding: 5, margin: 5,borderRadius : 10 }}>
            <h4 className="text-sm">STAGE1</h4>
            <h2 className="text-md">{preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "RSI-Minus30-Plus70" && preWatcher?.currentStage == "STAGE1").length}</h2>
          </div>

        </div>

        {/* STAGE2 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          STAGE2
        </h3>
        <div style={{ padding: 5 }}>
          <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="text-sm py-2 px-4 border-b">S.No.</th>
  <th className="text-sm py-2 px-4 border-b">Last Updated Date & Time</th>
                <th className="text-sm py-2 px-4 border-b">Creation Date & Time</th>
              
                <th className="text-sm py-2 px-4 border-b">Symbol & Current Price</th>

                {props.user.userType == 'ADMIN' ? (
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                ) : null}

                {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
              </tr>
            </thead>

            <tbody>
              {/* sort by desc order */}
              {preWatchersWithPrices.filter(preWatcher => preWatcher.strategyName === "RSI-Minus30-Plus70" && preWatcher?.currentStage == "STAGE2").sort((a, b) => new Date(b.lastChangedDate) - new Date(a.lastChangedDate)).map((preWatcher, index) => {

                return (
                  <tr key={preWatcher.uuid}>
                    {/* S.No */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                    </td>

                      {/* Updated Date & Time */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      {new Date(preWatcher.lastChangedDate).toLocaleDateString() +
                        ', ' +
                        new Date(preWatcher.lastChangedDate).toLocaleTimeString(undefined, {
                          hour12: true,
                        })}
                    </td>

                    {/* Creation Date & Time */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      {new Date(preWatcher.creationDate).toLocaleDateString() +
                        ', ' +
                        new Date(preWatcher.creationDate).toLocaleTimeString(undefined, {
                          hour12: true,
                        })}
                    </td>
                   

                    {/* Symbol */}
                    <td className="py-2 px-4 border-b">
                           <div style={{ alignItems: 'center', display: 'flex' }}>
                         
                          <button
                            style={{
                              backgroundColor: '#0474c9',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() => {
                              // if (props.user?.userType == 'ADMIN') {

                              //   window.open(
                              //     'https://www.coinglass.com/tv/Binance_' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // } else {
                              //   window.open(
                              //     'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                              //     '_blank'
                              //   )
                              // }
                            }
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preWatcher.symbol}</h4>

                           
                             
                            </div>
                          </button>
                           {props.user?.userType == 'ADMIN' ?

                              <a
                                href={`https://www.coinglass.com/tv/Binance_${preWatcher.symbol}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                                title="CoinGlass"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ display: 'inline', verticalAlign: 'middle' }}
                                >
                                  {/* Dark background circle matching trading terminal themes */}
                                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                                  <path
                                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  {/* Subtle outer border for depth */}
                                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                                </svg>
                              </a>
                              : null}
                            <a
                              href={`https://www.tradingview.com/chart/?symbol=BINANCE%3A${preWatcher.symbol}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}
                              title="TradingView"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'inline', verticalAlign: 'middle' }}
                              >
                                {/* Standard Terminal Background */}
                                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                                {/* Border for UI consistency */}
                                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                              </svg>
                            </a>
                            </div>
                        </td>

                    {/* Delete Button */}
                    <td className="py-2 px-4 border-b">
                      <div style={{ textAlign: 'center' }}>
                        <button
                          style={{
                            // backgroundColor: '#00ff00',

                            padding: 5,
                          }}
                          onClick={() => handleDelete(preWatcher.uuid)}
                        >
                          {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="size-4"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                );

              })}
            </tbody>
          </table>
          <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
            *Note: Signals will be removed automatically after 7 days.
          </h6>
        </div>


      </div>




    </div>
  ) : null;
};

function PreWatcherPopup({ preWatcher, onClose, transitionPreWatcherToWatcher }) {
  const wsRefBinance = useRef(null);
  const [limitPrice, setLimitPrice] = useState(null)
  const [stopLossPrice, setStopLossPrice] = useState(null)
  const [symbolCurrentPrice, setSymbolCurrentPrice] = useState(null)
  useEffect(() => {
    if (preWatcher && preWatcher.currentPrice) {
      setLimitPrice(Number(preWatcher.currentPrice).toFixed(preWatcher.numberOfDecimalValues));
      setStopLossPrice(Number(preWatcher.lowestPrice).toFixed(preWatcher.numberOfDecimalValues));
      subscribeToSymbols([preWatcher.symbol]);
    }
  }, [preWatcher]);

  // Function to subscribe to real-time Binance prices
  const subscribeToSymbols = async (symbols) => {
    console.log("Subscribing to Binance prices for:", symbols.length);
    unsubscribeFromSymbols();
    const streams = symbols.map(symbol => `${symbol.toLowerCase()}@ticker`).join('/');
    const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

    wsRefBinance.current = new WebSocket(url);

    wsRefBinance.current.onmessage = event => {
      const message = JSON.parse(event.data);
      const { s: symbol, c: currentPrice } = message.data;
      //  console.log(`Real-time price update for ${symbol}: ${currentPrice}`);
      setSymbolCurrentPrice(currentPrice)
    };

    wsRefBinance.current.onerror = err => {
      // console.error("Binance WebSocket error:", err);
    };

    wsRefBinance.current.onclose = () => {
      // console.log("Binance WebSocket closed");
    };
  };

  // Function to unsubscribe/cleanup
  const unsubscribeFromSymbols = () => {
    if (wsRefBinance.current) {
      wsRefBinance.current.close();
      wsRefBinance.current = null;
      // console.log('Unsubscribed from Binance prices');
    }
  };

  if (!preWatcher) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
      onClick={onClose}
    >
      <div
        id="preWatcher-popoup"
        style={{
          width: '450px',
          backgroundColor: '#fff',
          padding: 24,
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          paddingRight: 10,
        }}
        onClick={e => e.stopPropagation()}
      >

        {/* 1st row */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
          }}
        >
          <h1 style={{ color: "blue", fontWeight: "bold" }}>{preWatcher.symbol}
            ({Number(symbolCurrentPrice).toFixed(preWatcher.numberOfDecimalValues)})
          </h1>
          <button
            style={{
              padding: '4px',
              borderWidth: 1,
              borderColor: "red",
              color: 'red',
              borderRadius: 6,
              fontSize: 11,
              cursor: 'pointer',
            }}
            onClick={() => {
              unsubscribeFromSymbols()
              onClose()
            }}
          >
            Close
          </button>
        </div>
        <hr></hr>

        {symbolCurrentPrice ?
          <>
            {/* 2nd Row */}
            <div
              style={{
                display: 'flex',
                // justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 30,
                gap: 20
              }}
            >
              <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Limit Price:</h1>
              <button
                style={{
                  padding: 3,
                  backgroundColor: 'red',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35
                }}
                onClick={() => {

                  let ll = limitPrice
                  setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))

                  let sl = stopLossPrice
                  if (Number(sl) >= Number(limitPrice)) {
                    setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (2 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                  }

                }}
              >
                -
              </button>
              <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{limitPrice}</h1>

              <button
                style={{
                  padding: 3,
                  backgroundColor: 'green',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35

                }}
                onClick={() => {

                  let ll = limitPrice
                  setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                +
              </button>





            </div>

            {/* 3rd Row */}
            <div
              style={{
                display: 'flex',
                // justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 30,
                gap: 20
              }}
            >
              <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Stop Loss Price:</h1>
              <button
                style={{
                  padding: 3,
                  backgroundColor: 'red',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35
                }}
                onClick={() => {
                  let ll = stopLossPrice
                  setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                -
              </button>
              <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{stopLossPrice}</h1>

              <button
                style={{
                  padding: 3,
                  backgroundColor: 'green',
                  color: '#fff',
                  borderRadius: 50,
                  fontSize: 18,
                  cursor: 'pointer',
                  width: 35,
                  height: 35

                }}
                onClick={() => {
                  let ll = stopLossPrice
                  setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
                }}
              >
                +
              </button>
            </div>

            {/* 4th row */}
            <div
              style={{
                display: 'flex',
                marginBottom: 8,
                justifyContent: "center",
                columnGap: 5
              }}
            >
              <button
                style={{
                  padding: '5px',
                  borderWidth: 1,
                  borderColor: "blue",
                  color: 'blue',
                  borderRadius: 6,

                  cursor: 'pointer',
                  marginTop: 30,
                  fontSize: 14,


                }}
                onClick={() => {
                  transitionPreWatcherToWatcher({ preWatcher, limitPrice, stopLossPrice, symbolCurrentPrice })
                }}
              >
                Add to Watcher
              </button>


            </div>
          </>
          : null}
      </div>
    </div>
  );
}

export default PreWatchersComponent;
